import React from "react";
import { classes } from "./header.st.css";
import bcLogo from "../../assets/bc-logo-black.svg";
import Brand from "../../../components/Brand/Brand";
import SiteMenu from "../SiteMenu/SiteMenu";
import Icon from "../../../components/Icon/Icon";
/** Theme selector */
import { ThemeBar, changeTheme } from "../ThemeSelector/themeSelector";

interface HeaderProps {
  /** Depending on component menu, display menuToggle button */
  menuToggle?: boolean;
  /** Prop for activating the developer mode */
  toggleDevMode?: any;
  /** Prop that determines if side nav should display */
  toggleSideNav?: any;
  /** Determines if mobile mode is enabled to set icons */
  mobile?: boolean;
}

/** Current theme stored in local storage */
const theme = localStorage.currentTheme || "default";
changeTheme(theme);

const Header = ({
  toggleDevMode,
  toggleSideNav,
  menuToggle,
  mobile
}: HeaderProps) => {
  return (
    <header className={classes.root}>
      <div className={classes.brandContainer}>
        <Brand
          className={classes.brand}
          logoHref="/bronte/"
          logoText="Bronte"
          logoHeight={30}
          logoWidth={30}
          imgHref={bcLogo}
        />
        <span className={classes.slogan}>Bronte</span>
      </div>
      <div className={classes.headerNav}>
        <SiteMenu />
        <ThemeBar theme={theme} />
        {menuToggle && (
          <button
            className={classes.menuToggle}
            aria-controls="side-nav"
            onClick={toggleSideNav}
          >
            {mobile ? (
              <Icon className={classes.cross} title="Menu" icon="x" />
            ) : (
              <Icon className={classes.hamburger} title="Close" icon="menu" />
            )}
          </button>
        )}
        <button
          className={classes.devToggleButton}
          onClick={toggleDevMode}
          title="Toggle full width"
        >
          <Icon icon="layout" />
        </button>
      </div>
    </header>
  );
};

export default Header;
